import {Package} from './Package';
import {FileManager} from '../../shared/Models/FileManager';
import {SystemUser} from '../../shared/Models/SystemUser';

export class GeneralTerm {
  public id: number;
  public number: number;
  public createdAt: string;
  public file: FileManager;
  public comment: string;
  public terms: string;
  public user: SystemUser;
}
